<div class="menu-container">

  <!-- dashboard user info -->
  <mat-accordion multi="true" *ngIf="!systemService.inGameMode$.value">

    <!-- user info -->
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <i class="icon-lg light-blue ri-user-6-fill"></i> &nbsp; <strong>{{ 'MENU.USER.WELCOME' | translate: {value: user.fullName} }}</strong>
        
        <div fxLayout="row" fxLayoutAlign="center center" class="white-background menu-separator">
          <img src="assets/images/parts/bottom-shadow.png" />
        </div>
      </mat-expansion-panel-header>
      
      
      <div fxLayout="column" fxLayoutAlign="start start" class="user-info-container">
        <!-- readonly -->
        <ng-container *ngIf="!inEdition">
          <div><label>{{ 'MENU.USER.NAME' | translate }}:</label> <strong><span>{{user.fullName}}</span></strong></div>
          <div><label>{{ 'MENU.USER.EMAIL' | translate }}:</label><strong><span>{{user.username}}</span></strong></div>
          <div><label>{{ 'MENU.USER.PASSWORD' | translate }}:</label><strong><span>{{encryptedPassword}}</span></strong></div>

          <div style="pointer-events: none;">
            <label>{{ 'MENU.USER.LANG' | translate }}:</label>
            <ngx-flag-picker
              [selectedCountryCode]="user.language_in_use === 'uk' ? 'gb': user.language_in_use"
              [showFlags]="true"
              [showLabels]="false"
              [countryCodes]="countryCodes"
              [showArrow]="false"
              (changedCountryCode)="changeSelectedCountryCode($event)">
            </ngx-flag-picker>
          </div>
        </ng-container>

        <!-- editing -->
        <ng-container *ngIf="inEdition">
          <div><label>{{ 'MENU.USER.NAME' | translate }}:</label> <strong><span>{{user.fullName}}</span></strong></div>
          <div>
            <label>{{ 'MENU.USER.EMAIL' | translate }}:</label>
            <input type="text" [(ngModel)]="user.username" style="width: 120px;">
          </div>
          <div>
            <label>{{ 'MENU.USER.PASSWORD' | translate }}:</label>            
            <input type="password" [(ngModel)]="user.password" style="width: 120px;">             
          </div>

          <div><label>{{ 'MENU.USER.LANG' | translate }}:</label>
            <ngx-flag-picker
              [selectedCountryCode]="user.language_in_use === 'uk' ? 'gb': user.language_in_use"
              [showFlags]="true"
              [showLabels]="false"
              [countryCodes]="countryCodes"
              [showArrow]="true"
              (changedCountryCode)="changeSelectedCountryCode($event)">
            </ngx-flag-picker>
          </div>
        </ng-container>
        
        <!-- actions -->
        <span class="icon-button dark-blue" (click)="edit()" *ngIf="!inEdition">
          <i class="icon-md ri-edit-2-line"></i>
          {{ 'MENU.USER.EDIT' | translate }}
        </span>

        <div *ngIf="inEdition">
          <span class="icon-button dark-blue" (click)="save()">
            <i class="icon-md ri-save-line"></i>
            {{ 'MENU.USER.SAVE' | translate }}
          </span>

          <span class="icon-button dark-blue" (click)="cancelEdition()">
            <i class="icon-md ri-close-circle-line"></i>
            {{ 'MENU.USER.CANCEL' | translate }}
          </span>
        </div>


        <!-- logout -->
        <span class="icon-button dark-blue" (click)="logout.emit()">
          <i class="icon-md ri-logout-box-r-line"></i>
          {{ 'MENU.USER.LOGOUT' | translate }}
        </span>

      </div>
  
    </mat-expansion-panel>
  
    <!-- resume -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <i class="icon-lg light-blue ri-history-line"></i> &nbsp; <strong>{{ 'MENU.TRANING.HISTORY' | translate }}</strong>

        <div fxLayout="row" fxLayoutAlign="center center" class="white-background menu-separator">
          <img src="assets/images/parts/bottom-shadow.png" />
        </div>
      </mat-expansion-panel-header>
      
      
      <div class="training-info-container">
        <div><label>{{ 'MENU.TRAINING.TOTAL.TIME' | translate }}:</label> <strong>{{user.totalTime}}</strong></div>
        <div><label>{{ 'MENU.TRAINING.COURSE.STARTED' | translate }}:</label><strong>{{user.startDate}}</strong></div>
        <div><label>{{ 'MENU.TRAINING.LAST.LESSON' | translate }}:</label><strong>{{ 'MENU.TRAINING.LAST.LESSON.VALUE' | translate: {lesson: user.lastLesson, exercise: user.lastExercise} }}</strong></div>
        <div><label>{{ 'MENU.TRAINING.LAST.SPEED.NO' | translate }}:</label> <strong>{{user.speedExerciseReached}}</strong></div>
        <div><label>{{ 'MENU.TRAINING.EXAMS.TAKEN' | translate }}:</label><strong>{{user.howManyExams}}</strong></div>
        <div><label>{{ 'MENU.TRAINING.COURSE.COMPLETED' | translate }}:</label><strong>{{user.courseProgressInfo}}%</strong></div>
        <div><label>{{ 'MENU.TRAINING.KEYS.LEARNED' | translate }}:</label> <strong>{{ 'MENU.TRAINING.KEYS.LEARNED.VALUE' | translate: {value: user.keysLearned} }}</strong></div>
      </div>
  
    </mat-expansion-panel>
  
  </mat-accordion>

  <!-- dashboard game mode -->
  <mat-accordion multi="true" *ngIf="systemService.inGameMode$.value">

    <!-- start  -->
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <i class="icon-lg light-blue ri-run-line"></i> &nbsp; <strong>{{ 'MENU.START' | translate }}</strong>

        <div fxLayout="row" fxLayoutAlign="center center" class="white-background menu-separator">
          <img src="assets/images/parts/bottom-shadow.png" />
        </div>
      </mat-expansion-panel-header>
  
      <div fxLayout="column" fxLayoutAlign="start start" class="start-container">       
        <mat-list>
          <mat-list-item>
            <strong>
              <a mat-button [routerLink]="'/keylesson'" class="dark-blue" routerLinkActive="active-link">{{ 'MENU.START.KEYLESSONS' | translate }}
                <span class="lesson-progress-label">{{ 'MENU.START.KEYLESSONS.COMPLETED' | translate: {value: keyLessonsProgress} }}</span>
              </a>
              
            </strong>
          </mat-list-item>          

          <mat-list-item>
            <strong>
              <a mat-button [routerLink]="'/advancedlesson'" class="dark-blue" routerLinkActive="active-link">{{ 'MENU.START.ADVANCEDLESSONS' | translate }}              
                <span class="lesson-progress-label">{{ 'MENU.START.ADVANCEDLESSONS.COMPLETED' | translate: {value: advancedLessonsProgress} }}</span>
              </a>
            </strong>
          </mat-list-item>          

          <mat-list-item>
            <div matTooltip="{{ !isUnlockedExam ? ('MENU.START.UNLOCK.EXAM' | translate) : '' }}" matTooltipClass="custom-tooltip light-blue-background">
              <strong [ngClass]="{'isLocked': !isUnlockedExam}">
                <a mat-button [routerLink]="'/exam'" class="dark-blue" routerLinkActive="active-link">{{ 'MENU.START.EXAM' | translate }}</a>
                <i *ngIf="!isUnlockedExam" class="icon-lg ri-lock-fill light-blue" style="font-size: 12px;"></i>
              </strong>
            </div>
          </mat-list-item>          
          <mat-list-item>
            <strong>
              <a mat-button [routerLink]="'/home'" class="dark-blue" routerLinkActive="active-link">{{ 'MENU.START.HOME' | translate }}</a>
            </strong>
          </mat-list-item>         
         </mat-list>

      </div>
  
    </mat-expansion-panel>

    <!-- Bookmarks  -->
    <mat-expansion-panel class="bookmark-panel">
      <mat-expansion-panel-header>
        <i class="icon-lg light-blue ri-bookmark-3-line"></i> &nbsp; <strong>{{ 'MENU.BOOKMARKS' | translate }}</strong>
        
        <div fxLayout="row" fxLayoutAlign="center center" class="white-background menu-separator">
          <img src="assets/images/parts/bottom-shadow.png" />
        </div>
      </mat-expansion-panel-header>
      

      <div fxLayout="column" fxLayoutAlign="start start" class="bookmarks-container">       
        <mat-list>
          <mat-list-item *ngFor="let bookmark of bookmarks">
            <a mat-button (click)="navigateToBookmark(bookmark.title)">{{ bookmark.title }}</a>
          </mat-list-item>          
         </mat-list>
      </div>
  
    </mat-expansion-panel>

    <!-- Course progress  -->
    <mat-expansion-panel class="progress-panel">
      <mat-expansion-panel-header>
        <i class="icon-lg light-blue ri-timer-line"></i> &nbsp; <strong>{{ 'MENU.PROGRESS' | translate }}</strong>
        
        <div fxLayout="row" fxLayoutAlign="center center" class="white-background menu-separator">
          <img src="assets/images/parts/bottom-shadow.png" />
        </div>
      </mat-expansion-panel-header>
      

      <div fxLayout="column" fxLayoutAlign="start start" class="progress-container">       
        <mat-list>
          <mat-list-item *ngFor="let keylesson of courseProgress.keyLessons">
            <span>{{ 'MENU.COURSE.PROGRESS.KEY.LESSON' | translate: {value: keylesson.id} }} </span>
          </mat-list-item>          
          <mat-list-item *ngFor="let advancedlesson of courseProgress.advancedLessons">
            <span>{{ 'MENU.COURSE.PROGRESS.ADVANCED.LESSON' | translate: {value: advancedlesson.id} }} </span>
          </mat-list-item>          
         </mat-list>
      </div>
  
    </mat-expansion-panel>

    <!-- Results  -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <i class="icon-lg light-blue ri-bar-chart-box-line"></i> &nbsp; <strong>{{ 'MENU.RESULTS' | translate }}</strong>

        <div fxLayout="row" fxLayoutAlign="center center" class="white-background menu-separator">
          <img src="assets/images/parts/bottom-shadow.png" />
        </div>
      </mat-expansion-panel-header>
      

      <div fxLayout="column" fxLayoutAlign="start start" class="results-container">       
        <mat-list>
          <mat-list-item>
            <strong>
              <a mat-button [routerLink]="'/keyresults'" class="dark-blue" routerLinkActive="active-link">{{ 'MENU.RESULTS.KEYRESULTS' | translate }}</a>              
            </strong>
          </mat-list-item>  
          
          <mat-list-item>
            <strong>
              <a mat-button [routerLink]="'/advancedresults'" class="dark-blue" routerLinkActive="active-link">{{ 'MENU.RESULTS.ADVANCEDRESULTS' | translate }}</a>              
            </strong>
          </mat-list-item>  

        </mat-list>

      </div>
  
    </mat-expansion-panel>
  </mat-accordion>

</div>